<template>
  <div>
    <b-row>
      <div class="text-center">
        <h3 class="mt-4">{{ $t('pages.campaign.campaign_rules.title') }}</h3>
        <p class="text-muted font-size-14  mb-5">
          {{ $t('pages.campaign.campaign_rules.subtitle') }}
        </p>
      </div>

      <b-col sm="12">
        <div class="mb-3">
          <label class="control-label">{{ $t('pages.campaign.campaign_rules.buyer_purchase_count') }}
            <hint>{{ $t('pages.campaign.campaign_rules.infos.buyer_purchase_count_info') }}</hint>
          </label>
          <div class="mt-2 mb-3">
            <quantity-input :min="0" :max="5" v-model="selectedPurchaseCount"></quantity-input>
          </div>
        </div>
      </b-col>
      <b-col sm="12">
        <div class="mb-3">
          <label class="control-label">{{ $t('pages.campaign.campaign_rules.asin_filter.title') }}
            <hint>{{ $t('pages.campaign.campaign_rules.infos.asin_filter_info') }}</hint>
          </label>
          <b-tabs pills nav-class="bg-light rounded" content-class="mt-4" v-model="type">
            <b-tab :title="$t('pages.campaign.campaign_rules.asin_filter.include')" active>
              <b-card-text>
                <div>
                  <product-tabs
                      v-model="selectedIncludeFilters"
                      regex="([A-Z0-9]{10})"
                      :place-holder="$t('pages.campaign.campaign_rules.asin_placeholder')"
                  />
                  <b-btn
                      size="sm"
                      variant="link"
                      @click="handleFilterModal"
                  >
                    <i class="mdi mdi-magnify-plus-outline"></i>
                    {{ $t('pages.campaign.campaign_rules.add_catalog_title') }}
                  </b-btn>
                </div>
              </b-card-text>
            </b-tab>
            <b-tab :title="$t('pages.campaign.campaign_rules.asin_filter.exclude')">
              <b-card-text>
                <div>
                  <product-tabs
                      v-model="selectedExcludeFilters"
                      regex="([A-Z0-9]{10})"
                      :place-holder="$t('pages.campaign.campaign_rules.asin_placeholder')"
                  />
                  <b-btn
                      size="sm"
                      variant="link"
                      @click="handleFilterModal"
                  >
                    <i class="mdi mdi-magnify-plus-outline"></i>
                    {{ $t('pages.campaign.campaign_rules.add_catalog_title') }}
                  </b-btn>
                </div>
              </b-card-text>
            </b-tab>
          </b-tabs>
          <b-alert variant="danger" show class="mt-1"
                   v-if="$v.selectedExcludeFilters.$error
                   || $v.selectedIncludeFilters.$error
                   || asinError && submitted">
            <div
                v-if="!$v.selectedIncludeFilters.maxLength"
                class="invalid-feedback d-flex"
            >
              <i class="mdi mdi-block-helper me-2"></i>
              {{
                $t('pages.campaign.campaign_rules.validations.include_max',
                    {val: $v.selectedIncludeFilters.$params.maxLength.max})
              }}
            </div>
            <div
                v-if="!$v.selectedExcludeFilters.maxLength"
                class="invalid-feedback d-flex"
            >
              <i class="mdi mdi-block-helper me-2"></i>
              {{
                $t('pages.campaign.campaign_rules.validations.exclude_max',
                    {val: $v.selectedExcludeFilters.$params.maxLength.max})
              }}
            </div>
<!--            <div-->
<!--                v-if="asinError && submitted"-->
<!--                class="invalid-feedback d-flex"-->
<!--            >-->
<!--              <i class="mdi mdi-block-helper me-2"></i>-->
<!--              {{ $t('pages.campaign.campaign_rules.validations.not_contain_same') }}-->
<!--            </div>-->
          </b-alert>
        </div>
      </b-col>
      <exclude-filter @selected="setSelectedFilters"></exclude-filter>
    </b-row>
  </div>
</template>

<script>
import ProductTabs from "../ProductTabs";
import ExcludeFilter from "../ExcludeFilter";
import QuantityInput from "../../../../../components/widgets/QuantityInput";
import {maxLength} from "vuelidate/lib/validators";

export default {
  name: "CampaignFilter",
  components: {ProductTabs, ExcludeFilter, QuantityInput},
  data() {
    return {
      selectedPurchaseCount: 0,
      purchaseCountOptions: [0, 1, 2, 3, 4],
      selectedIncludeFilters: null,
      selectedExcludeFilters: null,
      type: null,
      asinError: false,
      submitted: false
    }
  },
  validations: {
    selectedIncludeFilters: {
      maxLength: maxLength(30),
    },
    selectedExcludeFilters: {
      maxLength: maxLength(30)
    },
  },
  methods: {
    handleFilterModal() {
      this.$bvModal.show('catalog-product-modal')
    },
    setSelectedFilters(e) {
      const type = this.type === 0 ? 'selectedIncludeFilters' : 'selectedExcludeFilters'
      this[type] = [...this[type], ...e.map(x => x.asin)]
    },
    validate() {
      this.$v.$touch();
      const isValid = !this.$v.$invalid;
      const data = {
        purchaseCount: this.selectedPurchaseCount,
        includeFilters: this.selectedIncludeFilters,
        excludeFilters: this.selectedExcludeFilters
      }
      this.$emit('on-validate', data, isValid)
      return isValid
    }
  }
}
</script>

<style scoped>

</style>